<template>
  <div>
    <label v-if="showLabel" class="control-label" :for="name" :class="{ invalid: error }"> {{ name }} </label>

    <div class="wrapper" :class="{ focus: focus, invalid: error }" @click="clickOutside()">

      <div v-for="(tag, index) in value" :key="tag" class="inline">
        <span class="label label-success">
          <span v-if="type === 'date'">{{ tag | moment("DD/MM/YY") }}</span>
          <span v-else>{{ tag }}</span>
          <button @click="remove(index)" type="button" class="btn btn-link" :disabled="blocked"><i class="fa fa-close"/></button>
        </span>
        <span class="text-between" v-if="textBetween != '' && index < value.length - 1">{{ textBetween }}</span>
      </div>

      <input :type="htmlType" ref="input" :name="name" :placeholder="placeholderVisible() ? placeholder : ''" v-model.trim="tag"
        @focus="onFocus()" @blur="onBlur()" @keyup="onKeyUp($event)" @keydown="onKeyDown($event)"
        :disabled="blocked" :class="{blocked: blocked }" />

    </div>
    <span v-if="error && showErrorLabel" class="error">{{ error }}</span>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        tag: '',
        focus: false
      }
    },

    props: {
      value: { type: Array, default: () => [] },
      name: { type: String, default: 'Tags' },
      placeholder: { type: String, default: 'Separe usando vírgula.' },
      separator: { type: String, default: ',' },
      textBetween: { type: String, default: '' },
      type: { type: String, default: 'text' },
      error: { type: String },
      showLabel: { type: Boolean, default: true },
      showErrorLabel: { type: Boolean, default: true },
      blocked: { type: Boolean, default: false }
    },

    methods: {

      pushTag () {
        if(this.tag !== '') {
          const tag = this.convert(this.tag)
          this.tag = ''
          if (this.value.indexOf(tag) === -1) {
            this.value.push(tag)
            this.$emit('input', this.value)
          }
        }
      },

      convert(val) {
        switch (this.type) {
          case 'float': return parseFloat(val)
          case 'integer': return parseInt(val)
          default: return val
        }
      },

      onKeyUp(event) {
        if (event.key === this.separator) {
          this.pushTag()
        }
      },

      onKeyDown(event) {
        if(event.key === this.separator) {
          event.preventDefault()
        }
        if (event.key === 'Backspace' && this.tag === '') {
          this.tag = this.value[this.value.length - 1] || ''
          this.value.pop()
        }
      },

      onFocus() { this.focus = true; this.$emit('focus') },
      onBlur() { this.focus = false; this.pushTag(); this.$emit('blur') },
      placeholderVisible() { return this.tag === '' && this.value.length === 0 },
      clickOutside() { this.$refs.input.focus() },

      remove(index) {
        this.value.splice(index, 1)
        this.$emit('input', this.value)
      }

    },

    computed: {
      htmlType() {
        return this.type === 'float' || this.type === 'integer' ? 'number' : this.type
      }
    },

    $_veeValidate: {
      name() {
        return this.name;
      },
      value() {
        return this.value;
      }
    }

  }
</script>

<style scoped >
  .wrapper {
    cursor: text;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    white-space: nowrap;
    border: 1px solid #e5e6e7;
    padding: 0 6px;
    text-align: left;
    font-size: 14px;
  }

  .inline { display: inline-block; }

  .label {
    padding: 1px 4px;
    margin: 4px 3px;
    font-size: 14px;
    display: inline-block;
  }

  input, input:focus {
    border: none!important;
    outline: none;
    padding: 6px 4px;
    flex-grow: 1;
    height: 34px;
  }

  .blocked { cursor: not-allowed; }

  .text-between { margin-right: 3px; }

  ::placeholder { color: #999; }

  .label button{ padding: 0; margin: 0; }
  .label button:hover { color:#979B9D; }

  .focus { border-color: #1c84c6; }
  .invalid { border-color: #e02c50; }
</style>



// WEBPACK FOOTER //
// src/components/InputTag.vue